"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCategoryValidToUploadImage = exports.isAdInactive = exports.isAdExpired = exports.isAdDeleted = exports.CATEGORIES = void 0;
var CATEGORIES = exports.CATEGORIES = {
  services: '7060',
  jobs: '7020',
  computers: '2000'
};
var isAdInactive = exports.isAdInactive = function isAdInactive(adStatus) {
  return isAdExpired(adStatus) || isAdDeleted(adStatus);
};
var isAdExpired = exports.isAdExpired = function isAdExpired(adStatus) {
  return adStatus === 'expired';
};
var isAdDeleted = exports.isAdDeleted = function isAdDeleted(adStatus) {
  return adStatus === 'deleted';
};
var isCategoryValidToUploadImage = exports.isCategoryValidToUploadImage = function isCategoryValidToUploadImage(category) {
  return category !== CATEGORIES.jobs && category !== CATEGORIES.services;
};